import * as Long from "long";
import { ofType } from "redux-observable";
import { filter, mapTo, switchMapTo, take } from "rxjs/operators";
import { IdResource } from "../../../constants/IdResource";
import { selectLimitedActionInfo } from "../../../selectors/selectLimitedActionInfo";
import { LimitedActionType } from "../../../utils/network/generated/protoTypes";
import { utilLimitedActionTime } from "../../../utils/utilLimitedActionTime";
import { utilTick } from "../../../utils/utilTick";
import { actionInventoryInfoAddResource } from "../../info/inventory/actionInventoryInfo";
import { TypeActionLimitedActionInfo } from "../../limited-action-info/actionLimitedActionInfo";
export var epicTimeDoghouseFreeTreat = function (action$, state$) {
    return action$.pipe(ofType(TypeActionLimitedActionInfo.Received), switchMapTo(utilTick.second$), filter(function () {
        var state = state$.value;
        var limitedActionInfo = selectLimitedActionInfo(state, LimitedActionType.DOGHOUSE);
        var secondsLeft = utilLimitedActionTime.getLimitedActionResetRemainingTime(limitedActionInfo);
        return secondsLeft <= 0;
    }), mapTo(actionInventoryInfoAddResource([
        {
            amount: Long.ONE,
            typeId: IdResource.DogtreatStandard,
        },
    ])), take(1));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/time/epics/epicTimeDoghouseFreeTreat.ts
// module id = 2434
// module chunks = 3